import { defineMessages } from 'react-intl'

export const strings = defineMessages({
  upload: {
    id: 'Cropper.upload',
    defaultMessage: 'Upload Image',
  },
  share: {
    id: 'Cropper.share',
    defaultMessage: 'Share a photo',
  },
})
